import { render, staticRenderFns } from "./MaterialGenetico.vue?vue&type=template&id=7f59926c&scoped=true"
import script from "./MaterialGenetico.vue?vue&type=script&lang=js"
export * from "./MaterialGenetico.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=7f59926c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59926c",
  null
  
)

export default component.exports